import React from 'react'

export const IcoContextoestrategico = ({ style = {} }) => {
  return (
    <svg
      className='icon-contextoestrategico'
      viewBox='0 0 16 16'
      style={style}
    >
      <g transform='translate(-3.2 -3.2) scale(0.02265625)'>
        <path d='M532.329 857.22L512.5 874.685l-19.829-17.465C307 693.686 213 558.981 213 448.5 213 283.09 347.09 149 512.5 149S812 283.09 812 448.5c0 110.481-93.999 245.186-279.671 408.72zM752 448.5C752 316.228 644.772 209 512.5 209S273 316.228 273 448.5c0 84.558 79.145 201.26 239.5 346.017C672.855 649.76 752 533.057 752 448.5zM513 559c-67.379 0-122-54.621-122-122 0-67.379 54.621-122 122-122 67.379 0 122 54.621 122 122 0 67.379-54.621 122-122 122z m0-60c34.242 0 62-27.758 62-62 0-34.242-27.758-62-62-62-34.242 0-62 27.758-62 62 0 34.242 27.758 62 62 62z' />
      </g>
    </svg>
  )
}